import { useSelector } from "react-redux";
import StepInfo from "./StepInfo";
import CheckpointItem from "./CheckpointItem/CheckPointItem";
import { shouldRenderCheckpoint } from "../../../utils/factoryCheckpointVisibilityRules";
import { areStageDependenciesSatisfied } from "../../../utils/jobCardDependencyUtils";

const JobCardStage = ({ setupData, currentStep, stepConfig = {} }) => {
  const jobCardData = useSelector((state) => state.jobCard.data);

  const { checkpoints, dependsOnIds } = setupData;

  const { stageUpdates, cylinder } = jobCardData;

  const updatedCheckPoints = stageUpdates.find(
    (s) => s.stageId === currentStep,
  )?.checkpointUpdates;

  /* ------------------ Dependency Disable ------------------ */
  const areStageDependenciesComplete = dependsOnIds
    ? areStageDependenciesSatisfied(dependsOnIds, stageUpdates)
    : true;

  /* ------------------ Custom Disable Logic ------------------ */
  const isCustomDisabled = stepConfig?.getStageDisable?.({
    stageUpdates,
  });
  
   /* ------------------ Custom Action Hidden Logic ------------------ */ 
  const actionHidden = stepConfig?.actionHidden?.({
    stageUpdates,
  });

  const isDisabled = !areStageDependenciesComplete || isCustomDisabled;
  /* ------------------ Custom Visibility Source ------------------ */
  const visibilitySource =
    stepConfig?.visibilitySource?.(stageUpdates) || updatedCheckPoints;

  const CheckpointComponent = stepConfig?.CheckpointComponent || CheckpointItem;

  return (
    <>
      <StepInfo info={setupData} cylinderSerialNo={cylinder.serialNumber} />

      <div className={`form-step-wrap ${isDisabled ? "disable-bx" : ""}`}>
        {checkpoints
          .filter((cp) => cp.isActive)
          .filter((cp) =>
            stepConfig?.useVisibility
              ? shouldRenderCheckpoint(cp.id, visibilitySource)
              : true,
          )
          .map((checkpoint) => {
            /* -------- Special Checkpoint Override -------- */
            if (stepConfig?.renderCheckpointOverride) {
              const customRender = stepConfig.renderCheckpointOverride({
                checkpoint,
                cylinder,
              });

              if (customRender) return customRender;
            }

            return (
              <CheckpointComponent
                key={checkpoint.id}
                checkpoint={checkpoint}
                updatedCheckPoints={updatedCheckPoints}
                discardCondition={stepConfig?.discardConditions?.find(
                  (c) => c.id === checkpoint.id,
                )}
                actionHidden={actionHidden}
              />
            );
          })}
      </div>
    </>
  );
};

export default JobCardStage;
